/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Martial_ArtsInputs */

const en_service_type_martial_arts = /** @type {(inputs: Service_Type_Martial_ArtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Martial arts`)
};

const pl_service_type_martial_arts = /** @type {(inputs: Service_Type_Martial_ArtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sztuki walki`)
};

/**
* | output |
* | --- |
* | "Martial arts" |
*
* @param {Service_Type_Martial_ArtsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_martial_arts = /** @type {((inputs?: Service_Type_Martial_ArtsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Martial_ArtsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_martial_arts(inputs)
	return en_service_type_martial_arts(inputs)
});